import { useMemo } from 'react';
import { useCustomMask } from '@direct-frontend/components';

export const useTrimMask = () => {
    const trimMaskProps = useMemo(() => {
        return {
            mask: [...Array(255).fill(/[^ \s]/)],
            transformToUnmasked: (value: string) => value.trim(),
        };
    }, []);

    return useCustomMask(trimMaskProps);
};
